import clsx from 'clsx'

/**
 * 列表在小屏下的卡片形态（≥md 仍用原表格）。
 *
 * 两条刻意的取舍：
 * 1. 字段用「标签 值」紧挨着排，不做两端对齐 —— 两端对齐在窄屏上中间留一大片空白，
 *    眼睛要左右来回跳，行数一多就显得乱。
 * 2. 卡片自带边框并由外层给间距，不用分隔线 —— 分隔线会让多条记录连成一片，数不清有几条。
 *
 * 调用方负责把一行数据映射成 title/subtitle/badge/fields/actions；禁用状态的操作按钮
 * 请直接不要传进来（灰按钮对用户没有信息，只有噪音）。
 */
export default function MobileCard({
  title,
  subtitle,
  badge,
  fields = [],
  actions,
  children,
  onClick,
  className,
}) {
  const visibleFields = fields.filter(Boolean)

  return (
    <div
      className={clsx(
        'rounded-lg border border-gray-200 bg-white px-4 py-3.5',
        onClick && 'cursor-pointer active:bg-gray-50',
        className
      )}
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="font-medium text-gray-900 break-words">{title}</div>
          {subtitle && <div className="mt-1 text-xs text-gray-500 break-words">{subtitle}</div>}
        </div>
        {badge && <span className="shrink-0">{badge}</span>}
      </div>

      {visibleFields.length > 0 && (
        <dl className="mt-2.5 space-y-1 text-sm">
          {visibleFields.map((f) => (
            <div key={f.label} className="flex gap-1.5">
              <dt className="shrink-0 text-gray-500">{f.label}</dt>
              <dd className="min-w-0 text-gray-800 break-words">
                {f.value === null || f.value === undefined || f.value === '' ? '-' : f.value}
              </dd>
            </div>
          ))}
        </dl>
      )}

      {children}

      {actions && <div className="mt-3 flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  )
}
